/**
 * The love-chart check's form props, shared by the server-rendered shell
 * (LoveChartCheckLazy), the island's BirthDetailsForm and
 * BirthToolFormShell.parity.test.tsx, so every frame before and after the island
 * loads reads the same words. No name field: the answer does not use one. The
 * birth time is required: the 5th and 7th houses and their lords are counted
 * from the Lagna, which moves into the next sign about every two hours.
 */
export const LOVE_CHART_CHECK_FORM = {
  language: "en",
  submitLabel: "Check My Love Chart",
  collectName: false,
  requireBirthTime: true,
} as const;

/**
 * One box for every state of the check's slot (the rashi check's frame,
 * RASHI_CHECK_FRAME): the shell, the loading shell, the live form and the answer
 * each fill the slot's reserved height, and the submit sits at the foot of the
 * box in every state with one 48 px height.
 */
export const LOVE_CHART_CHECK_FRAME =
  "mx-auto flex w-full max-w-md flex-1 flex-col [&>form]:flex [&>form]:flex-1 [&>form]:flex-col [&>form>:last-child]:mt-auto [&>form>:last-child]:min-h-12";

/**
 * The form's room: the slot's floor (LoveChartCheckLazy) and, once the answer's
 * room is added, the form frame's own height, so the submit stays where the
 * press found it instead of sliding to the foot of the taller box.
 */
export const LOVE_CHART_FORM_RESERVE = "min-h-[520px] sm:min-h-[460px]";

/**
 * The answer's room, added by the island inside the submit itself, before the
 * request goes out (the varshphal check's verdict reserve): the growth happens
 * in the press, an input-driven change rather than a layout shift, and the
 * reply, an error or a retry all land inside it; only "Check another birth date"
 * releases it. Measured 2026-10-14 on next dev with POST /kundali mocked by a
 * typical reply (Kanya lagna, two activation lines, Mangal dosha) and a worst
 * case (Mesh lagna: three activation lines, every Venus flag, a cancelled Mangal
 * dosha), with the check in the page's hero: the tallest answer is 814 px at 320
 * wide, 778 at 360, 760 at 390, 726 at 414, 656 at 480 and 638 from 639 up
 * (re-measured after the review fixes: the FAQ's wording and an always-shown
 * Mangal row). A static reserve this tall would leave ~400 px of
 * blank under the form for every reader who never checks a chart.
 */
export const LOVE_CHART_ANSWER_RESERVE = "min-h-[840px] sm:min-h-[660px]";

/** The real form's input ids (no heading prop, so BirthDetailsForm's "-default" ids). */
export const LOVE_CHART_CHECK_FIELD_IDS = {
  date: "birthDate-default",
  time: "birthTime-default",
  place: "birthPlace-default",
} as const;

/** free_tool_started and calculator_used placement for the /love-horoscope/ check. */
export const LOVE_CHART_CHECK_PLACEMENT = "love_horoscope_page_check";
